import {useNavigation} from '@react-navigation/native';
import * as React from 'react';
import {StyleProp, ViewStyle} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {requestContactChange} from '../../../../redux/actions/profile';
import {holderProfileSelector} from '../../../../redux/selectors/profile';
import {EvenOddListItemContentFactoryProps} from '../../../../shared/components/evenOddList';
import {useModal} from '../../../../shared/components/modal';
import {RegExps} from '../../../../shared/constants/regexps';
import {RequestedOperationType} from '../../../../shared/models/api';
import {ValidationItem} from '../../../../shared/pipes';
import {maskPrivateData, PrivateDataMaskType} from '../../../../shared/pipes/maskPrivateData';
import {Screens} from '../../../../shared/routing';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';
import {PossibleChangeField} from '../possibleChangeField';
import {EmailConfirmationModal} from './components/emailConfirmationModal';

const fieldName = 'email';

const validationItems: ValidationItem[] = [
  {
    names: fieldName,
    error: 'Обязательное поле',
    type: 'required',
  },
  {
    names: fieldName,
    error: 'Неправильный адрес электронной почты',
    type: 'pattern',
    pattern: RegExps.email,
  },
];

interface Props extends EvenOddListItemContentFactoryProps {
  testID?: string;
  style?: StyleProp<ViewStyle>;
}

export const EmailChangeField: React.FC<Props> = (props) => {
  const {isMasked} = props;
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const profile = useSelector(holderProfileSelector());
  const modals = useModal();

  const value = React.useMemo(() => {
    let rawValue = profile?.email ?? '';

    if (isMasked && rawValue) {
      rawValue = maskPrivateData(rawValue, {maskType: PrivateDataMaskType.email});
    }

    return rawValue;
  }, [profile, isMasked]);

  const onChange = async (newValue: string) => {
    try {
      await dispatch(requestContactChange(newValue, RequestedOperationType.SetEmailConfirmation));
      if (deviceSize === DeviceSize.desktop) {
        modals.show({
          render(modal, methods) {
            const hideModal = () => {
              methods.remove(modal.id);
            };
            return <EmailConfirmationModal onClose={hideModal} />;
          },
        });
      } else {
        navigation.navigate(Screens.ProfileUserEmailConfirmation);
      }
    } catch (err) {
      let errorText = err.data?.[0]?.message || err.message || 'Ошибка. Попробуйте позже';
      console.log('error', errorText);
      // TODO: this is not working!!!
      // JUST COMMENT NOW
      // throw new SubmissionError({
      //   [fieldName]: new FormValidationError(errorText, true),
      // } as FormErrors<any, FormValidationError>);
    }
  };

  return (
    <PossibleChangeField
      type={fieldName}
      value={value}
      onChange={onChange}
      validationItems={validationItems}
      {...props}
      isMasked
    />
  );
};
